import { theme, useMediaQuery } from 'academy-common-lib/utils/Styling';
import { H2 } from 'UIComponents/elements/headings';
import UIButton from 'UIComponents/button/UIButton';
import HorizontalLayoutContainer from '../publicLayout/components/HorizontalLayoutContainer';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getProxyUrl } from 'academy-common-lib/utils/url';
import StyledSection from '../publicLayout/components/StyledSection';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TrendingTopicButton = ({
  topicName,
  children
}) => /*#__PURE__*/_jsx(UIButton, {
  href: getProxyUrl(`/courses?cat=${topicName}`),
  size: "large",
  use: "tertiary-light",
  children: children
});
const TrendingTopicsSection = () => {
  const {
    isMobile
  } = useMediaQuery();
  return /*#__PURE__*/_jsx(StyledSection, {
    backgroundColor: theme.colors.GYPSUM,
    className: "text-center",
    children: /*#__PURE__*/_jsxs(HorizontalLayoutContainer, {
      children: [/*#__PURE__*/_jsx(H2, {
        className: "m-bottom-10",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academyPublic.trendingTopics.title"
        })
      }), /*#__PURE__*/_jsxs("div", {
        style: {
          display: 'flex',
          justifyContent: 'center',
          rowGap: isMobile ? '4px' : '12px',
          flexWrap: 'wrap'
        },
        children: [/*#__PURE__*/_jsx(TrendingTopicButton, {
          topicName: 'SOCIAL_MEDIA',
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "academyPublic.trendingTopics.socialMedia"
          })
        }), /*#__PURE__*/_jsx(TrendingTopicButton, {
          topicName: 'EMAIL_MARKETING',
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "academyPublic.trendingTopics.emailMarketing"
          })
        }), /*#__PURE__*/_jsx(TrendingTopicButton, {
          topicName: 'SEO',
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "academyPublic.trendingTopics.seo"
          })
        }), /*#__PURE__*/_jsx(TrendingTopicButton, {
          topicName: 'INBOUND_SALES',
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "academyPublic.trendingTopics.inboundSales"
          })
        }), /*#__PURE__*/_jsx(TrendingTopicButton, {
          topicName: 'CONTENT_MARKETING',
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "academyPublic.trendingTopics.contentMarketing"
          })
        })]
      })]
    })
  });
};
export default TrendingTopicsSection;